import styled from "styled-components";
import { Heading, PageFooter } from "@puregym/ui";

const StyledPageFooter = styled(PageFooter)`
  & [id="language-switcher"] {
    border-block-end: ${({ theme }) =>
      `1px solid ${theme.colors.accents.muted}`};
    padding-block-end: ${({ theme }) => theme.spacing.baseSpacing};
  }
  & :last-child {
    border-block-end: none;
    padding-block-end: 0;
  }
`;

const Languages = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.baseSpacing};
`;

const Language = styled.a`
  display: inline-flex;
  font-size: ${({ theme }) => theme.fontSizes.small};

  &[dir="ltr"] {
    font-family: ${({ theme }) => theme.fonts.body};
  }

  &[dir="rtl"] {
    font-family: ${({ theme }) => theme.rtlFonts.body};
  }
`;

const NavWrapper = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) =>
    `${theme.spacing.doubleSpacing} ${theme.spacing.baseSpacing}`};
  padding: ${({ theme }) => `${theme.spacing.baseSpacing} 0`};

  ${({ theme }) => theme.mediaQueries.sm} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  }
`;
const NavHeading = styled(Heading)`
  margin-block-end: ${({ theme }) => theme.spacing.baseSpacing};
  color: ${({ theme }) => theme.colors.text};
`;

const NavLink = styled.a`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.text};
  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
  }
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSizes.xsmall};
  margin-block-start: ${({ theme }) => theme.spacing.baseSpacing};

  ${({ theme }) => theme.mediaQueries.md} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export {
  StyledPageFooter,
  Languages,
  Language,
  NavWrapper,
  NavHeading,
  NavLink,
  Row,
};
